import { Link } from 'react-router-dom';

const serviceLinks = [
  { label: 'Local Moving', path: '/services/local-moving' },
  { label: 'Residential Moving', path: '/services/residential-moving' },
  { label: 'Apartment Moving', path: '/services/apartment-moving' },
  { label: 'Commercial Moving', path: '/services/commercial-moving' },
  { label: 'Full-Service Moving', path: '/services/full-service-moving' },
  { label: 'Heavy-Item Moving', path: '/services/heavy-item-moving' },
  { label: 'Last-Minute Moving', path: '/services/last-minute-moving' },
];

const areaLinks = [
  'Minneapolis', 'St. Paul', 'Bloomington', 'Plymouth',
  'Woodbury', 'Maple Grove', 'Eagan', 'Eden Prairie',
  'Edina', 'Coon Rapids', 'Brooklyn Park', 'Burnsville',
];

const quickLinks = [
  { label: 'Home', path: '/' },
  { label: 'About Us', path: '/about' },
  { label: 'Services', path: '/services' },
  { label: 'Service Areas', path: '/locations' },
  { label: 'Get Free Quote', path: '/#quote' },
];

const Footer = () => {
  return (
    <footer className="bg-charcoal text-white">
      {/* Top CTA Strip */}
      <div className="bg-teal py-5">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="font-heading font-700 text-navy text-lg text-center md:text-left">
            Ready to Move? Get Your Free Quote Today
          </div>
          <div className="flex items-center gap-3">
            <a
              href="tel:+16123674481"
              className="bg-navy text-white font-heading font-600 px-5 py-2.5 rounded-lg text-sm hover:bg-navy-dark transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>(612) 367-4481
            </a>
            <Link
              to="/#quote"
              className="bg-white text-teal-dark font-heading font-700 px-5 py-2.5 rounded-lg text-sm hover:bg-cream transition-colors cursor-pointer whitespace-nowrap"
            >
              Free Quote
            </Link>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-5 cursor-pointer">
              <img
                src="https://static.readdy.ai/image/81164d3ba0f00c2a7e247a9f180c9b75/47f8f9906349aca5e74950df5c14b795.webp"
                alt="TrueCare Moving Services Logo"
                className="w-14 h-14 object-contain rounded-full"
              />
              <div>
                <div className="font-heading font-800 text-white text-lg leading-tight">TrueCare</div>
                <div className="text-teal text-[10px] tracking-[0.2em] uppercase leading-tight">Moving Services</div>
              </div>
            </Link>
            <p className="text-text-muted text-sm font-body leading-relaxed mb-6">
              Minneapolis's trusted, licensed, and insured moving company. Family-owned. A+ BBB rated. 231 five-star reviews. Serving the Twin Cities for 10+ years.
            </p>
            <div className="flex gap-3">
              {['facebook', 'instagram', 'linkedin', 'google'].map((s) => (
                <a
                  key={s}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-teal hover:text-navy rounded-lg text-text-muted transition-all duration-200 cursor-pointer"
                  rel="nofollow"
                >
                  <i className={`ri-${s}-fill text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-700 text-teal text-xs tracking-widest uppercase mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((l) => (
                <li key={l.path}>
                  <Link
                    to={l.path}
                    className="text-text-muted hover:text-teal text-sm font-body transition-colors duration-200 flex items-center gap-2 cursor-pointer"
                  >
                    <i className="ri-arrow-right-s-line text-teal text-xs"></i>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-700 text-teal text-xs tracking-widest uppercase mb-5">Services</h4>
            <ul className="space-y-3">
              {serviceLinks.map((l) => (
                <li key={l.path}>
                  <Link
                    to={l.path}
                    className="text-text-muted hover:text-teal text-sm font-body transition-colors duration-200 flex items-center gap-2 cursor-pointer"
                  >
                    <i className="ri-arrow-right-s-line text-teal text-xs"></i>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-700 text-teal text-xs tracking-widest uppercase mb-5">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-teal text-sm"></i>
                </div>
                <span className="text-text-muted text-sm font-body leading-relaxed">
                  121 Washington Ave S #332<br />Minneapolis, MN 55401
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-teal text-sm"></i>
                </div>
                <a href="tel:+16123674481" className="text-white hover:text-teal text-sm font-body transition-colors cursor-pointer">
                  (612) 367-4481
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-teal text-sm"></i>
                </div>
                <a href="mailto:truecaremovingservice@gmail.com" className="text-text-muted hover:text-teal text-xs font-body transition-colors cursor-pointer break-all">
                  truecaremovingservice@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-time-line text-teal text-sm"></i>
                </div>
                <span className="text-text-muted text-sm font-body">Mon–Sat: 7:00 AM – 10:00 PM</span>
              </li>
            </ul>

            <div className="mt-6">
              <h5 className="font-heading font-600 text-teal text-xs tracking-widest uppercase mb-3">Service Areas</h5>
              <div className="flex flex-wrap gap-1.5">
                {areaLinks.map((city) => (
                  <Link
                    key={city}
                    to={`/locations/${city.toLowerCase().replace(' ', '-').replace('.', '')}`}
                    className="text-text-muted hover:text-teal text-xs font-body transition-colors cursor-pointer"
                  >
                    {city}
                    <span className="text-white/20 ml-1.5">·</span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10 py-5">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-text-muted text-xs font-body">
            © 2026 TrueCare Moving Services LLC. All Rights Reserved. Licensed &amp; Insured in Minnesota.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-text-muted hover:text-teal text-xs font-body transition-colors cursor-pointer" rel="nofollow">Privacy Policy</a>
            <span className="text-white/20">|</span>
            <a href="#" className="text-text-muted hover:text-teal text-xs font-body transition-colors cursor-pointer" rel="nofollow">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
